import './admin.scss';
import React, { useState, useEffect } from 'react';
import domReady from '@wordpress/dom-ready';
import { createRoot } from '@wordpress/element';
import { Panel, PanelBody, TabPanel, PanelRow, Button, Spinner, Modal } from '@wordpress/components';
import EnquiryButtonTab from './admin/EnquiryButtonTab';
import EnquiryListTab from './admin/EnquiryListTab';
import GeneralSettingTab from './admin/GeneralSettingTab';
import IncludeExcludeTab from './admin/IncludeExcludeTab';
import FormCustomizerTab from './admin/FormCustomizerTab';
import EmailCustomizerTab from './admin/EmailCustomizerTab';
import TranslationTab from './admin/TranslationTab';
import DocumentationTab from './admin/DocumentationTab';




const AdminApp = () => {
    const [isPopupOpen, setIsPopupOpen] = useState(false); // State for popup visibility
    const [popupMessage, setPopupMessage] = useState(''); // State for popup message

    const openPopup = (message) => {
        setPopupMessage(message);
        setIsPopupOpen(true);
    };

    const closePopup = () => {
        setIsPopupOpen(false);
        setPopupMessage('');
    };
    const tabs = [

        {
            name: 'EnquiryButtonTab',
            title: 'Enquiry Button Settings',
            content: <EnquiryButtonTab openPopup={openPopup} />,
        },
        {
            name: 'EnquiryListTab',
            title: 'Enquiry List',
            content: <EnquiryListTab openPopup={openPopup} />,
        },
        {
            name: 'GeneralSettingTab',
            title: 'General Setting',
            content: <GeneralSettingTab openPopup={openPopup} />,
        },
        {
            name: 'IncludeExcludeTab',
            title: 'Include/Exclude',
            content: <IncludeExcludeTab openPopup={openPopup} />,
        },
        {
            name: 'FormCustomizerTab',
            title: 'Form Customizer',
            content: <FormCustomizerTab openPopup={openPopup} />,
        },
        {
            name: 'EmailCustomizerTab',
            title: 'Email Customizer',
            content: <EmailCustomizerTab openPopup={openPopup} />,
        },
        {
            name: 'TranslationTab',
            title: 'Translate',
            content: <TranslationTab openPopup={openPopup} />,
        },
        {
            name: 'DocumentationTab',
            title: 'Documentation',
            content: <DocumentationTab />,
        }

    ];

    return (
        <>
            <Panel>
                <TabPanel
                    className=""
                    activeClass="active-tab"
                    tabs={tabs}
                >
                    {(tab, selected) => (
                        <div
                            className={`tab-content ${tab.name === selected ? 'active-tab' : ''
                                }`}
                        >
                            {tab.content}
                        </div>
                    )}
                </TabPanel>
            </Panel>
            {isPopupOpen && (
                <Modal title={popupMessage} onRequestClose={closePopup}>
                </Modal>
            )}
        </>
    );
};


domReady(() => {
    const root = createRoot(
        document.getElementById('GMWQP-admin-root')
    );
    root.render(<AdminApp />);
});